<!--
 * @Author: Dzy
 * @Date: 2022-11-11 16:44:21
 * @LastEditors: Dzy
 * @LastEditTime: 2023-02-20 09:51:55
 * @Description: 通用UI库图标
-->
<template>
  <span v-if="!avatar" @mouseover="mouseOver" @mouseleave="mouseLeave">
    <!-- 应用阿里icon组件  官方固定写法  不封装也可以在页面中直接使用-->
    <svg v-if="!hoverFlag" class="icon" aria-hidden="true">
      <use :xlink:href="'#icon-' + iconHref" />
    </svg>
    <svg v-else class="icon" aria-hidden="true">
      <use :xlink:href="'#icon-' + iconHref + '_hov'" />
    </svg>
  </span>
  <span v-else>
    <svg class="icon-avatar" aria-hidden="true">
      <use :xlink:href="'#icon-' + iconHref" />
    </svg>
  </span>
</template>
<script setup>
import { ref } from 'vue'
const props = defineProps({
  iconHref: String, // 图标地址
  allowHover: Boolean, // 悬浮切换图标样式
  avatar: Boolean // 是否应用于头像
})

const hoverFlag = ref(false)

const mouseOver = () => {
  if (props.allowHover) {
    hoverFlag.value = true
  }
}

const mouseLeave = () => {
  if (props.allowHover) {
    hoverFlag.value = false
  }
}

/*
  iconHref 说明：
  icon id说明
  组成：{文件类型}_{适用类型}_{功能}(_{使用场景}(default默认场景不填))
  文件类型：i:图标；p：图片；v：视频；s:特殊文件
  适用类型：common：通用类型；table：专用于表格类型；form：专用于表单类型
  功能：编辑：edit；重置密码:resetPwd;……
  使用场景：hov：悬浮场景
  例如：
  i_common_edit:通用类型默认编辑图标
*/
</script>
